<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>

            
              <form-group label="Select Partner User">
                <v-select
                  label="name"
                  :options="partners"
                  :filterable="false"
                  @search="getPartners"
                  :reduce="(partner) => partner.id"
                  v-model="message.to_user_id"
                >
                  <template slot="no-options">
                    Type to search partners 
                  </template>
                  <template slot="option" slot-scope="c">
                    <div>
                      {{ c.name }}<br />
                      {{ c.email }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="c">
                    {{ c.name }}<br>
                    {{ c.email }}
                  </template>
                </v-select>

                <small v-if="$v.message.to_user_id.$error" class="text-danger">
                  Please select partner
                </small>

              </form-group>

               <form-group label="Link to Job#">
                <v-select
                  label="job_number"
                  :options="jobs"
                  :filterable="false"
                  @search="getJobs"
                  :reduce="(job) => job.id"
                  v-model="message.job_id"
                >
                  <template slot="no-options">
                    Type to search jobs
                  </template>
                  <template slot="option" slot-scope="c">
                    <div>
                     # {{ c.job_number }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="c">
                    # {{ c.job_number }}
                  </template>
                </v-select>
            

              </form-group>

            <form-group label="Subject" :required="true">
              <input
                type="text"
                @blur="$v.message.subject.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.message.subject.$error }"
                v-model="message.subject"
            
              />
              <div class="invalid-feedback" v-if="!$v.message.subject.required">
                Please enter subject
              </div>
            
            </form-group>

            <form-group label="Message" :required="true">
              <textarea-autosize 
               
                @blur="$v.message.message.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.message.message.$error }"
                v-model="message.message"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.message.message.required"
              >
                Please enter mesage
              </div>
            </form-group>

         

            <form-group label="Image">
              <image-upload
                @files-uploaded="
                  message.image_id = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="false"
                :imageCrop="false"
                :validationState="imageVstate"
                acceptedTypes="image/*"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import messagingRepo from "@/api/repos/messagingRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    message: {
      to_user_id:{
        required
      },
      subject: {
        required,
      },
      message: {
        required,
      },
    },
  },

  mounted() {},

  data() {
    return {
      jobs:[],
      partners:[],
      message: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    getPartners(search) {
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.partnerSearch(search);
        }, 500);
      }
    },

    async partnerSearch(search) {
      try {
        let { data } = await messagingRepo.searchPartners(search);
        this.partners = data.partners;
      } finally {
        this.loading = false;
      }
    },

    getJobs(search) {
      if (search.length > 0) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.jobSearch(search);
        }, 500);
      }
    },

    async jobSearch(search) {
      try {
        let { data } = await messagingRepo.searchJobs(search);
        this.jobs = data.jobs;
      } finally {
        this.loading = false;
      }
    },


    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await messagingRepo.create(this.message);
          this.$emit("messageCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style></style>
